import { Box } from "@modernatx-internal/component-library";
import React from "react";

import { ContentComponentProps, NavBarAnchorContent } from "@/content-V2/types";

import { useNavBarContext } from "./NavBarContext";

export const NavBarAnchor: React.FC<ContentComponentProps<NavBarAnchorContent>> = ({
  children,
  id
}) => {
  const { registerAnchor, unregisterAnchor } = useNavBarContext();
  const ref = React.useRef<HTMLElement | null>(null);

  React.useEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    registerAnchor(id, element);

    return () => {
      unregisterAnchor(id);
    };
  }, [id, registerAnchor, unregisterAnchor]);

  return (
    <Box ref={ref} id={id} sx={{ scrollMarginTop: "72px" }}>
      {children}
    </Box>
  );
};
